var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__wrapper"},[_c('img',{staticClass:"message__image",attrs:{"src":"#","alt":"image"}}),_c('p',{staticClass:"message__title"},[_vm._v("No pudimos guardar los cambios. Por favor, inténtalo de nuevo.")])])
}]

export { render, staticRenderFns }